import { Provider } from "../../../classes/provider/Provider";

const googleDriveProvider = new Provider({
	id: "google_drive",
	name: "Google drive",
	description:
		"Google Drive is a file storage and synchronization service developed by Google. Launched on April 24, 2012, Google Drive allows users to store files on their servers, synchronize files across devices, and share files.",
	websiteHomeUrl: "https://drive.google.com/",
	websiteSupportUrl: "https://support.google.com/drive",
	iconUrl:
		"https://storage.googleapis.com/cdn.version2.io/providers/google-drive.png",
	color: "#FFFFFF",
});

export default googleDriveProvider;
